import { LOCATION_CHANGE } from 'connected-react-router'
import { ofType } from 'redux-observable'
import { empty, of } from 'rxjs'
import { delayWhen, filter, switchMap, catchError } from 'rxjs/operators'
import { isProductFetched } from 'domain/resources'
import { isProductPageAction } from 'domain/router'
import { captureException } from 'helpers/raven'
import { queryFromString } from 'helpers/url'
import { postProductVisit } from 'api/planet/visits'
import * as Actions from 'store/actions/index.ts'
import { getIsSaleFetched, getIsLastViewedProductFeatureEnabled } from 'store/selectors'
import { awaitForProductFetched } from './helpers/resources'

const productVisitEpic = (actions$, state$) => (
  actions$.pipe(
    ofType(LOCATION_CHANGE),
    filter(action => (
      getIsLastViewedProductFeatureEnabled(state$.value) &&
      isProductPageAction(action)
    )),
    delayWhen(locationChangeAction => {
      const resourceFetched$ = actions$.pipe(ofType(Actions.resources.RESOURCE_FETCHED))
      const locationChangeKey = queryFromString(locationChangeAction.payload.location.search).key
      return (getIsSaleFetched(state$.value) && isProductFetched(locationChangeKey))
        ? of({})
        : awaitForProductFetched(locationChangeKey, resourceFetched$, state$)
    }),
    switchMap(locationChangeAction => (
      postProductVisit(state$.value).pipe(
        switchMap(() => empty()),
        catchError(error => {
          captureException(new Error('Unable to periodically post current product visited'), {
            extra: { error },
            level: 'warning'
          })
          return of(Actions.errors.onPostProductVisitError(error))
        })
      )
    ))
  )
)

export default productVisitEpic
